// Interfaz con los datos del documento del trámite
export interface IDocumento {
  DOCUMENTO: string;
  tipo: string;
  OBLIGATORIO: boolean;
}

// Interfaz con los datos del trámite
export class ITramite {
  id_tramite: number;
  id_fk_area: number;
  TRAMITE: string;
  DTOAREA: string;
  INFO_AREA: string;
  INFO_TRAMITE: string;
  DOCUMENTOS: IDocumento[];
}

// Clase con los datos del documento del trámite
export class cDocumento {
  public DOCUMENTO = "";
  public tipo = "";
  public OBLIGATORIO = "";
  public INFO(): string {
    return this.DOCUMENTO + " - " + this.tipo + " (" + this.OBLIGATORIO + ")";
  }
}

// Clase con los datos del trámite
export class cTramite {
  public id_tramite = 0;
  public id_fk_area = 0;
  public TRAMITE = "";
  public DTOAREA = "";
  public INFO_AREA = "";
  public INFO_TRAMITE = "";
  public DOCUMENTOS = new Array<cDocumento>();
}

// Convierte una colección de objetos interface ITramite a un array de cTramite.
// Carga los trámies de todas las áreas (idArea = 0) o de un área concreta
export function convertirAClase(
  DATA_TRAMITES: ITramite[],
  idArea: number,
): cTramite[] {
  const aTramites = new Array<cTramite>();

  for (let i = 0; i <= DATA_TRAMITES.length - 1; i++) {
    if (idArea === 0 || idArea === DATA_TRAMITES[i].id_fk_area) {
      const oTramite: cTramite = new cTramite();
      oTramite.id_tramite = DATA_TRAMITES[i].id_tramite;
      oTramite.id_fk_area = DATA_TRAMITES[i].id_fk_area;
      oTramite.TRAMITE = DATA_TRAMITES[i].TRAMITE;
      oTramite.DTOAREA = DATA_TRAMITES[i].DTOAREA;
      oTramite.INFO_AREA = DATA_TRAMITES[i].INFO_AREA;
      oTramite.INFO_TRAMITE = DATA_TRAMITES[i].INFO_TRAMITE;

      const aDocumentos = new Array<cDocumento>();
      for (let n = 0; n <= DATA_TRAMITES[i].DOCUMENTOS.length - 1; n++) {
        const oDocumento: cDocumento = new cDocumento();
        oDocumento.DOCUMENTO = DATA_TRAMITES[i].DOCUMENTOS[n].DOCUMENTO;
        switch (DATA_TRAMITES[i].DOCUMENTOS[n].tipo) {
          case "O":
            oDocumento.tipo = "Original";
            break;
          case "F":
            oDocumento.tipo = "Fotocopia";
            break;
          case "C":
            oDocumento.tipo = "Fotocopia compulsada";
            break;
        }
        if (DATA_TRAMITES[i].DOCUMENTOS[n].OBLIGATORIO) {
          oDocumento.OBLIGATORIO = "Obligatorio";
        } else {
          oDocumento.OBLIGATORIO = "Opcional";
        }
        aDocumentos.push(oDocumento);
      }
      oTramite.DOCUMENTOS = aDocumentos;
      aTramites.push(oTramite);
    }
  }

  return aTramites;
}
